var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/arrow-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5101 15.1997L15.4801 13.2297L18.6901 10.0197C19.3601 9.33969 18.8801 8.17969 17.9201 8.17969H11.6901H6.08007C5.12007 8.17969 4.64007 9.33969 5.32007 10.0197L10.5001 15.1997C11.3201 16.0297 12.6801 16.0297 13.5101 15.1997Z",
    fill: "#5523D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownPurple);
export default __webpack_public_path__ + "static/media/arrow-down-purple.24d96e53d7b4a6843ec4b790426ff7a0.svg";
export { ForwardRef as ReactComponent };